<template lang="pug">
.is-flex.is-flex-direction-row.signin-container
  
  section.p-6.is-flex-grow-1.is-flex.is-flex-direction-column(style="overflow: scroll")
    .pb-3
      a(:href="`https://www.emly.${rootDomain}`" target="_blank")  
        img(src="../../../assets/logo_black.svg", style="height:36px;")
    .is-flex-grow-1.is-flex.is-align-items-center
      .columns.is-centered.is-flex-grow-1
        .column.is-8-desktop.is-10-tablet.is-12-mobile
          div

            template(v-if="step === 0")
              h1.title.is-3(v-t="'signup.signin_or_signup_title'")
              form(@submit.prevent="checkEmail")
                b-field(:label="$t('signup.email_label')" :type="errors.has('email') ? 'is-danger': ''" :message="errors.has('email') ? errors.first('email') : ''")
                  b-input(type="email" ref="emailInput" size="is-normal" v-validate="'required|email'" :placeholder="$t('signup.email_placeholder')" icon="at" v-model="email" name="email" data-qa="signin-email")
                //RecaptchaTerms.help.has-text-grey.mb-4
                .buttons
                  action-button.is-primary.is-fullwidth.is-medium(@click="checkEmail" title="actions.continue" :loading="submitting") 
                //vue-turnstile(@verified="token = $event" site-key="0x4AAAAAAAe2Easdn3MxJU_U" theme="light" appearance="always")
            template(v-else-if="step === 1")
              template(v-if="!notAvailableInRegion")
                h1.title.is-3(v-t="'signup.create_account_title'") 
                form(@submit.prevent="sendOTP")
                  b-field(:label="$t('signup.first_name_label')" :type="errors.has('firstName') ? 'is-danger': ''" :message="errors.has('firstName') ? errors.first('firstName') : ''")
                    b-input(size="is-normal" ref="firstNameInput" v-validate="'required'" :placeholder="$t('signup.first_name_placeholder')" icon="account-outline" v-model="firstName" name="firstName" data-qa="signin-firstName")
                  
                  b-field(:label="$t('signup.last_name_label')" :type="errors.has('lastName') ? 'is-danger': ''" :message="errors.has('lastName') ? errors.first('lastName') : ''")
                    b-input(size="is-normal" v-validate="'required'" :placeholder="$t('signup.last_name_placeholder')" icon="account-outline" v-model="lastName" name="lastName" data-qa="signin-lastName")
                  

                  b-field(:label="$t('signup.phone_label')", :type="errors.has('phone') || phoneValid === false ? 'is-danger': ''" :message="errors.has('phone') ? errors.first('phone') : (phoneValid === false ? 'The phone number is invalid': '')" expanded)
                    phone-input(size="is-normal" v-model="phone" ref="phoneInput" @input="(phone, valid) => phone ? phoneValid = valid : phoneValid = undefined"  v-validate="'required'" name="phone" :placeholder="$t('signup.phone_placeholder')" )
                  
                  hr
                  b-field(:label="$t('account_setup.password_label')" :type="errors.has('password') ? 'is-danger': ''" :message="errors.has('password') ? errors.first('password') : ''")
                    b-input(size="is-normal" 
                      type="password" 
                      ref="passwordInput" 
                      v-validate="'required|min:8|max:32|password'" 
                      :placeholder="$t('account_setup.password_placeholder')" 
                      icon="lock" 
                      v-model="password" 
                      name="password"
                      password-reveal)
                  b-field(:label="$t('account_setup.password_repeat_label')" :type="errors.has('passwordConfirm') ? 'is-danger': ''" :message="errors.has('passwordConfirm') ? errors.first('passwordConfirm') : ''")
                    b-input(
                      size="is-normal"
                      type="password" 
                      v-validate="{ is: password, required: true }" 
                      :placeholder="$t('account_setup.password_repeat_placeholder')" 
                      icon="lock" 
                      v-model="passwordConfirm" 
                      name="passwordConfirm"
                      password-reveal
                      data-vv-as="password confirmation")
                  //vue-turnstile(@verified="token = $event" site-key="0x4AAAAAAAe2Easdn3MxJU_U")
                  p.mb-3(v-html="$t('signup.legal_links')")
                  
                  //RecaptchaTerms.help.has-text-grey.mb-4

                  .buttons
                    action-button.is-primary.is-fullwidth.is-medium(@click="sendOTP" title="actions.continue" :loading="submitting") 
              template(v-else) 
                template(v-if="!waitingListJoined")
                  h1.title.is-3.mb-6(v-t="'signup.join_waiting_list'")
                  p.subtitle.is-5 Emly AI is actively expanding worldwide, and while we haven't reached your region yet, by joining our waiting list, you'll be among the first to experience it once available.
                  .buttons
                    action-button.is-primary.is-fullwidth.is-medium(@click="joinWaitingList" title="Join Now" :loading="submitting") 
                  hr
                  h2.title.is-5.mb-3.has-text-primary Why Join?
                  ul.mb-5
                    li 
                      b Priority Access: 
                      span Get exclusive early access to Emly AI as soon as it launches in your region.
                    li
                      b Stay Updated:
                      span Receive timely updates and news about Emly AI's availability.
                    li
                      b Become Part of Our Community:
                      span Connect with other enthusiasts and share your experiences.
                  
                  
                  p.subtitle.is-6 
                    em If you have any questions or feedback, 
                      a(href="mailto:support@emly.co" target="_blank") contact our support team.
                template(v-else)
                  success-screen
                    p.title.is-3 Thank you for joining the waiting list!
                    p.subtitle.is-5 Your enthusiasm is inspiring, and we're thrilled to have you on board. As we expand our reach, you'll be among the first to experience the potential of emly in your region.
            template(v-else-if="step === 2")
              h1.title.is-3(v-t="'otp.verify_phone_title'")
              
              form(@submit.prevent="createUser")
                p.subtitle.is-6(v-html="$t('otp.verification_prompt', {number: phone})")
                b-field(:label="$t('otp.otp_label')", :type="errors.has('otp') || otpError ? 'is-danger': ''" :message="errors.has('otp') ? errors.first('otp') : (otpError ? $t('otp.invalid_code_error') : '')" expanded)
                  input.input.is-medium(
                    v-model="otp" 
                    @input="onOTPInput"  
                    name="otp" 
                    ref="otpInput" 
                    placeholder="• • • • • •" 
                    style="text-align:center" 
                    type="text" 
                    autocomplete="one-time-code" 
                    inputmode="numeric" 
                    pattern="\d{6}"
                    :class="otpError ? 'is-danger' : ''")
                
                  
                .mb-4
                  p {{$t('otp.didnt_receive')}}
                  
                  p(v-if="remainingSeconds > 0" v-html="$t('otp.resend_prompt', {count: remainingSeconds})") 
                  p(v-else)
                    a(@click="sendOTP")  {{$t('otp.resend')}}
                    |  or    
                    a(@click="changeNumber")  {{$t('otp.change_number')}}
                //vue-turnstile(@verified="token = $event" site-key="0x4AAAAAAAe2Easdn3MxJU_U")
              .buttons
                action-button.is-primary.is-fullwidth.is-medium(@click="createUser" title="actions.submit" :loading="submitting") 
            .pt-3
              CloudflareTurnstile(ref="turnstile" :explicitRender="true" @verified="token = $event" site-key="0x4AAAAAAAe2Easdn3MxJU_U" appearance="interaction-only" theme="light") 
              //vue-turnstile(ref="turnstile" :explicitRender="true" autoReset @verified="token = $event" site-key="0x4AAAAAAAe2Easdn3MxJU_U" appearance="interaction-only") 
                

  section.p-6.signin-cover.is-flex-grow-1.is-hidden-touch.is-flex.is-flex-direction-row.is-align-items-end(:style="{'background-image': `url('${bgImage}')`}") 
    div
      .py-6
        h2.title.is-2.has-text-white(style="line-height: 1.25em") {{ quote.quote }}
        h3.title.is-4.has-text-white {{quote.author}}
        p.subtitle.has-text-white(v-if="quote.company") ({{ quote.company }})
    
      .pb-6
        h3.title.is-4.has-text-white(v-t="'signin.explore_more_title'")
        p 
          a.button.is-outlined.is-medium.is-white(:href="`https://www.emly.${rootDomain}`" target="_blank") 
            b(v-t="'actions.learn_more'")
            span.icon
              i.mdi.mdi-open-in-new
</template>
<script>
const images = [
  'https://images.pexels.com/photos/2104499/pexels-photo-2104499.jpeg?auto=compress&cs=tinysrgb&w=1600',
  'https://images.pexels.com/photos/6331049/pexels-photo-6331049.jpeg?auto=compress&cs=tinysrgb&w=1600',
  'https://images.pexels.com/photos/3293037/pexels-photo-3293037.jpeg?auto=compress&cs=tinysrgb&w=1600'
]

import QUOTES from '../../../../constants/salonQuotes'

import {mapActions} from 'vuex'
import AuthApi from '@/api/auth'
//import VueTurnstile from '@gaviti/vue-turnstile'
import CloudflareTurnstile from '../../shared/CloudflareTurnstile'
//import RecaptchaTerms from '../../shared/RecaptchaTerms'
//const STEPS = ['email', 'personal', 'otp', 'business']
export default {
  name: 'UserSignup',
  components: {
    //RecaptchaTerms,
    CloudflareTurnstile
    //VueTurnstile
  },
  data() {
    return {
      email: undefined,
      firstName: undefined,
      lastName: undefined,
      phone: undefined,
      password: undefined,
      passwordConfirm: undefined,
      otp: undefined,
      token: undefined,
      phoneValid: undefined,
      otpError: undefined,
      remainingSeconds: undefined,
      step: 0,
      submitting: false,
      notAvailableInRegion: false,
      waitingListJoined: false
    }
  },
  computed: {
    bgImage() {
      return images[Math.floor(Math.random() * images.length)]
    },
    quote() {
      let quotes = QUOTES[this.$i18n.locale] || QUOTES.en
      return quotes[Math.floor(Math.random() * quotes.length)]
    },
    rootDomain() {
      return window.location.hostname.split('.').pop()
    }
  },
  mounted() {
    this.$refs.emailInput.focus()
  },
  methods: {
    ...mapActions('auth', ['requestOTP', 'signupUser']),
    async checkEmail() {
      const valid = await this.$validator.validateAll()
      if (!valid || this.submitting || !this.token) {
        return
      }
      this.submitting = true
      try {
        //await this.$recaptchaLoaded()

        //const token = await this.$recaptcha('otp')
        let emailStatus = await AuthApi.checkEmail({email: this.email, token: this.token})
        if (emailStatus.exists) {
          this.$router.push({name: 'Signin', query: {email: this.email}})
        } else {
          this.step = 1
          this.$refs.turnstile.reset()

          await this.$nextTick()
          this.$refs.firstNameInput.focus()
        }
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.submitting = false
    },
    async sendOTP() {
      const valid = await this.$validator.validateAll()
      if (!valid || this.phoneValid === false || !this.phone || this.submitting || !this.token) {
        return
      }
      if (this.remainingSeconds > 0) {
        return
      }

      this.submitting = true
      this.remainingSeconds = 120
      this.otp = undefined
      try {
        //await this.$recaptchaLoaded()

        //const token = await this.$recaptcha('otp')
        await this.requestOTP({phone: this.phone, token: this.token, type: 'signup'})
        this.step = 2

        this.$refs.turnstile.reset()
        this.initWebOTP()
        this.interval = setInterval(() => {
          if (!this.remainingSeconds) {
            clearInterval(this.interval)
          }
          this.remainingSeconds -= 1
        }, 1000)

        await this.$nextTick()
        this.$refs.otpInput.focus()
      } catch (error) {
        if (error.status === 400 && error.body.code === 'NOT_AVAILABLE_IN_REGION') {
          this.notAvailableInRegion = true
        } else {
          this.$handleAPIError(error)
        }
      }
      this.submitting = false
    },
    async joinWaitingList() {
      if (this.submitting || !this.token) {
        return
      }
      this.submitting = true
      try {
        //const token = await this.$recaptcha('signup')
        await AuthApi.joinWaitingList({
          firstName: this.firstName,
          lastName: this.lastName,
          phone: this.phone,
          email: this.email,
          locale: this.$i18n.locale,
          token: this.token
        })
        this.waitingListJoined = true
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.submitting = false
    },
    changeNumber() {
      this.step = 1
      this.$refs.turnstile.reset()

      this.$nextTick(() => {
        this.$refs.phoneInput.focus()
      })
    },

    async initWebOTP() {
      try {
        let otp = await navigator.credentials.get({
          otp: {transport: ['sms']}
        })

        if (otp && otp.code && this.phone) {
          this.otp = otp.code
          this.createUser()
        }
      } catch (err) {
        console.log(err)
      }
    },
    async next() {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      this.step += 1
    },
    prev() {
      this.step -= 1
    },
    async createUser() {
      if (this.submitting || !this.token) {
        return
      }
      this.submitting = true
      try {
        //const token = await this.$recaptcha('signup')
        await this.signupUser({
          firstName: this.firstName,
          lastName: this.lastName,
          phone: this.phone,
          password: this.password,
          email: this.email,
          otp: this.otp,
          locale: this.$i18n.locale,
          token: this.token,
          metadata: this.$route.query
        })
        this.$router.push('/signup/business')
      } catch (err) {
        if (err.body && err.body.code === 'INVALID_OTP') {
          this.otpError = true
          this.otp = undefined
        } else if (err.body && err.body.code === 'EXISTING_ACCOUNT') {
          this.$handleAPIError(err)
          // TODO handle edge case
        } else {
          this.$handleAPIError(err)
        }
      }
      this.submitting = false
    },
    async onOTPInput() {
      if (this.otp) {
        this.otpError = false
        if (this.otp.length === 6) {
          await this.createUser()
        }
      }
    }
  }
}
</script>
<style scoped>
.signin-container section {
  flex-basis: 0;
}

.signin-cover {
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
}
</style>
